import { render, staticRenderFns } from "./verNota.vue?vue&type=template&id=5ab47ab2&"
import script from "./verNota.vue?vue&type=script&lang=js&"
export * from "./verNota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports